import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import { AuthContext } from '../../context/AuthContext';
import { TipoCustoContext } from '../../context/TipoCustoContext';
import { TipoCustoType, CreateTipoCustoType, UpdateTipoCustoType } from '../../context/hooks/useTipoCusto';
import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';

const TipoCusto = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listTipoCusto, tipoCustoPageCount, getAllTipoCustoPaged, createTipoCusto, updateTipoCusto, deleteTipoCusto } = useContext(TipoCustoContext);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [selectedTipoCustoId, setSelectedTipoCustoId] = useState(0);
    const [newTipoCusto, setNewTipoCusto] = useState<CreateTipoCustoType>({
        description: '',
        value: 0,
        isFinancial: false,
        isFixo: false,
        empresaId: objUserTk.EmpresaId,
    });
    const [editingTipoCusto, setEditingTipoCusto] = useState<UpdateTipoCustoType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [filters, setFilters] = useState({
        description: '',
        isFinancial: false,
    });
    const [dataSearch, setDataSearch] = useState({ description: '', isFinancial: false });

    useEffect(() => {
        setLoading(true);
        getAllTipoCustoPaged(1, 9, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar tipos de custo:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllTipoCustoPaged(value, 9, objUserTk.EmpresaId, filters.isFinancial, filters.description);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllTipoCustoPaged(1, 9, objUserTk.EmpresaId, filters.isFinancial, filters.description)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({ description: '', isFinancial: false });
        setLoading(true);
        getAllTipoCustoPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setNewTipoCusto(prevTipoCusto => ({
            ...prevTipoCusto,
            [name]: value === '' ? null : value
        }));
    };

    const handleCreateTipoCusto = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const payload = {
            ...newTipoCusto,
            type: newTipoCusto.description,
            isFinancial: newTipoCusto.isFinancial,
            empresaId: Number(newTipoCusto.empresaId)
        };

        createTipoCusto(payload)
            .then(createdTipoCusto => {
                if (createdTipoCusto) {
                    setCreateModalOpen(false);
                    setNewTipoCusto({
                        description: '',
                        value: 0,
                        isFinancial: false,
                        isFixo: false,
                        empresaId: objUserTk.EmpresaId,
                    });
                    getAllTipoCustoPaged(1, 9, objUserTk.EmpresaId);
                } else {
                    console.error("Erro ao criar tipo de custo.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar tipo de custo:", error);
            });
    };

    const handleEditTipoCusto = (tipoCusto: TipoCustoType) => {
        setEditingTipoCusto(tipoCusto);
        setEditModalOpen(true);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingTipoCusto) {
            const updatedData = {
                ...editingTipoCusto,
            };
            updateTipoCusto(updatedData)
                .then(updatedTipoCusto => {
                    if (updatedTipoCusto) {
                        setEditModalOpen(false);
                        getAllTipoCustoPaged(1, 9, objUserTk.EmpresaId);
                        setEditingTipoCusto(null);
                    } else {
                        console.error("Erro ao atualizar tipo de custo.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar o tipo da custo:", error);
                });
        }
    };

    const handleDeleteTipoCusto = (tipoCustoId: number) => {
        if (window.confirm("Tem certeza que deseja excluir este tipo de custo?")) {
            deleteTipoCusto(tipoCustoId)
                .then(deletedTipoCusto => {
                    if (deletedTipoCusto) {
                        getAllTipoCustoPaged(1, 9, objUserTk.EmpresaId);
                    } else {
                        console.error("Erro ao excluir tipo de custo.");
                    }
                    getAllTipoCustoPaged(1, 9, objUserTk.EmpresaId);
                })
                .catch(error => {
                    console.error("Erro ao excluir tipo de custo:", error);
                });
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Tipos de Custo"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">

                {/* <Col xs="12" md="5" lg="5" className="mb-2">
                    <Input
                        className="form-control-alternative"
                        type="text"
                        name="search"
                        id="search"
                        placeholder="Buscar por descrição"
                        value={dataSearch.description}
                        onChange={handleSearchChange}
                    />
                </Col>
                <Col xs="12" md="4" lg="4" className="mb-2">
                    <Input
                        className="form-control-alternative"
                        type="select"
                        name="isFinancial"
                        value={dataSearch.isFinancial}
                        onChange={(e) => setDataSearch({ ...dataSearch, isFinancial: e.target.value })}
                    >
                        <option value="">Tipo de Custo</option>
                        <option value="true">Financeiro</option>
                        <option value="false">Custo</option>
                    </Input>
                </Col>
                <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                    <Button
                        style={{ color: "#FFF", backgroundColor: "#585858" }}
                        type="button"
                        size="m"
                        onClick={handleSearchButtonClick}
                        className="mr-2"
                    >
                        Buscar
                    </Button>
                    <Button
                        style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                        type="button"
                        size="m"
                        onClick={handleClearFilters}
                    >
                        Limpar
                    </Button>
                </Col> */}

                <Row className="align-items-center mb-4">
                    {hasPermission(PermissionModule.Custos, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar tipo de custo
                            </Button>
                        </Col>
                    )}
                </Row>

                {hasPermission(PermissionModule.Custos, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Descrição</th>
                                        <th>Valor</th>
                                        <th>Tipo</th>
                                        <th>Custo Fixo</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listTipoCusto.map((tipoCusto: TipoCustoType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{tipoCusto.id}</td>
                                                <td>{tipoCusto.description}</td>
                                                <td>{tipoCusto.value}</td>
                                                <td>{tipoCusto.isFinancial ? "Financeiro" : "Custo"}</td>
                                                <td>{tipoCusto.isFixo ? "Sim" : "Não"}</td>
                                                <td>
                                                    {hasPermission(PermissionModule.Custos, 3) && (
                                                        <Button onClick={() => { handleEditTipoCusto(tipoCusto); setSelectedTipoCustoId(tipoCusto.id); }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {hasPermission(PermissionModule.Custos, 4) && (
                                                        <Button onClick={() => handleDeleteTipoCusto(tipoCusto.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {tipoCustoPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={tipoCustoPageCount}
                                        />
                                    </div>
                                )}
                                {listTipoCusto.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os tipos de custo.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <Modal isOpen={createModalOpen} toggle={() => setCreateModalOpen(!createModalOpen)} backdrop="static" size="lg">
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar novo tipo de custo</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCreateTipoCusto}>
                        <Row>
                            <Col md='6'>
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="input-description">
                                        Descrição do custo:
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="description"
                                        id="description"
                                        value={newTipoCusto.description}
                                        onChange={handleCreateInputChange}
                                        required
                                        placeholder="Ex: Canudo, Copo, Becas, etc..."
                                    />
                                </FormGroup>
                            </Col>
                            <Col md='3'>
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="input-value">
                                        Valor do custo:
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="number"
                                        name="value"
                                        id="value"
                                        value={newTipoCusto.value}
                                        onChange={handleCreateInputChange}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md='6'>
                                <FormGroup>
                                    <Label className="form-control-label">
                                        Tipo de custo:
                                    </Label>
                                    <div className="d-flex align-items-center" style={{ gap: '16px', marginTop: '8px' }}>
                                        <FormGroup check inline className="mb-0">
                                            <Label check>
                                                <Input
                                                    type="radio"
                                                    name="newIsFinancial"
                                                    checked={newTipoCusto.isFinancial === true}
                                                    onChange={() => setNewTipoCusto(prev => ({ ...prev, isFinancial: true, isFixo: false }))}
                                                />
                                                {' '}Financeiro
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline className="mb-0">
                                            <Label check>
                                                <Input
                                                    type="radio"
                                                    name="newIsFinancial"
                                                    checked={newTipoCusto.isFinancial === false}
                                                    onChange={() => setNewTipoCusto(prev => ({ ...prev, isFinancial: false }))}
                                                />
                                                {' '}Custo
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline className="mb-0">
                                            <Label check style={{ color: newTipoCusto.isFinancial ? '#aaa' : 'inherit' }}>
                                                <Input
                                                    type="checkbox"
                                                    checked={newTipoCusto.isFixo}
                                                    disabled={newTipoCusto.isFinancial === true}
                                                    onChange={e => setNewTipoCusto(prev => ({ ...prev, isFixo: e.target.checked }))}
                                                />
                                                {' '}Custo Fixo
                                            </Label>
                                        </FormGroup>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-3">
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Criar Tipo de Custo</Button>
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => setCreateModalOpen(!createModalOpen)} size="m" className="ml-2">Cancelar</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" className="custom-modal-xl">
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Editar informações do tipo de custo</ModalHeader>
                <ModalBody>
                    {editingTipoCusto && (
                        <>
                            <Form onSubmit={handleEditSubmit}>
                                <Row>
                                    <Col md='6'>
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-description">Tipo do custo</Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="text"
                                                name="description"
                                                id="description"
                                                value={editingTipoCusto.description}
                                                onChange={e => setEditingTipoCusto({ ...editingTipoCusto, description: e.target.value })}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md='3'>
                                        <FormGroup>
                                            <Label className="form-control-label" htmlFor="input-value">Valor do custo</Label>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                name="value"
                                                id="value"
                                                value={editingTipoCusto.value}
                                                onChange={e => setEditingTipoCusto({ ...editingTipoCusto, value: Number(e.target.value) })}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md='6'>
                                        <FormGroup>
                                            <Label className="form-control-label">Tipo de custo</Label>
                                            <div className="d-flex align-items-center" style={{ gap: '16px', marginTop: '8px' }}>
                                                <FormGroup check inline className="mb-0">
                                                    <Label check>
                                                        <Input
                                                            type="radio"
                                                            name="editIsFinancial"
                                                            checked={editingTipoCusto.isFinancial === true}
                                                            onChange={() => setEditingTipoCusto({ ...editingTipoCusto, isFinancial: true, isFixo: false })}
                                                        />
                                                        {' '}Financeiro
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check inline className="mb-0">
                                                    <Label check>
                                                        <Input
                                                            type="radio"
                                                            name="editIsFinancial"
                                                            checked={editingTipoCusto.isFinancial === false}
                                                            onChange={() => setEditingTipoCusto({ ...editingTipoCusto, isFinancial: false })}
                                                        />
                                                        {' '}Custo
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check inline className="mb-0">
                                                    <Label check style={{ color: editingTipoCusto.isFinancial ? '#aaa' : 'inherit' }}>
                                                        <Input
                                                            type="checkbox"
                                                            checked={editingTipoCusto.isFixo}
                                                            disabled={editingTipoCusto.isFinancial === true}
                                                            onChange={e => setEditingTipoCusto({ ...editingTipoCusto, isFixo: e.target.checked })}
                                                        />
                                                        {' '}Custo Fixo
                                                    </Label>
                                                </FormGroup>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-end">
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Salvar alterações</Button>
                                    <Button style={{ color: "#FFF", backgroundColor: "#585858" }} onClick={() => setEditModalOpen(!editModalOpen)} size="m">Cancelar</Button>
                                </div>
                            </Form>
                        </>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
};

export default TipoCusto;